import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07b47b9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "team-member-card",
    elevation: "4"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_avatar, { size: "100" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_img, {
              src: _ctx.member.avatar,
              alt: _ctx.member.name
            }, null, 8, ["src", "alt"])
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_card_title, { class: "member-name" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.member.name), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_subtitle, { class: "member-title" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.member.title), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, { class: "socials" }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.member.socials, (social) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              key: social.platform,
              href: social.url,
              target: "_blank",
              icon: "",
              variant: "text",
              size: "small"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getSocialIcon(social.platform)), 1)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["href"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}